import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const GraphiQLFooter = (t0) => {
  const $ = c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = /* @__PURE__ */ jsx("div", { className: "graphiql-footer", children });
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export {
  GraphiQLFooter
};
//# sourceMappingURL=footer.js.map
